/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { DividerComponent } from './divider';
export * from './divider-constants';
export * from './divider';
export function defineDividerComponent() {
    defineCustomElement(DividerComponent);
}
